<template>
    <v-layout column style="gap:4px" v-if="shows">
        <template v-if="!form.gift">
            <exchange-gifts
                v-bind="{
                    amount: form.amount,
                }"
                v-on="{
                    exec: send,
                }"
                v-slot="{
                    attrs,
                    on,
                }"
                ref="exchange-gifts"
            >
                <v-btn v-bind="{ ...attrs, loading }" color="primary" v-on="on">
                    <span>선물하기</span>
                </v-btn>
            </exchange-gifts>
        </template>
        <template v-else>
            <gift-info v-bind="{ value, loading }" v-on="{ redo, undo }" v-slot="{ attrs, on }" ref="gift-info">
                <v-btn v-bind="{ ...attrs, loading }" outlined color="primary" v-on="on">
                    <span>발송내역</span>
                </v-btn>
            </gift-info>
        </template>
    </v-layout>
    <span v-else> - </span>
</template>

<script>
import api from "@/api";
import { initUserExchangeBulk } from "@/assets/lib";

import ExchangeGifts from "@/components/client/exchange/exchange-gifts.vue";
import GiftInfo from "./gift/gift-info.vue";

export default {
    components: {
        ExchangeGifts,
        GiftInfo,
    },
    props: {
        /** @type {import('vue/types/umd').PropType<import('@/assets/lib').UserExchangeBulk>} */
        value: { type: Object, default: initUserExchangeBulk },
    },
    data: () => ({
        /** @type {import('@/assets/lib').UserExchangeBulk} */
        form: initUserExchangeBulk(),

        loading: false,
    }),
    computed: {
        shows() {
            return this.form.gifted || (!this.form.cashed && !this.form.undone);
        },
    },
    methods: {
        sync() {
            this.form = initUserExchangeBulk(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        async send({ phone }) {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { bulk } = await api.v1.me.exchanges.bulks.gift.postSend({
                    _id: this.form._id,
                    phone: phone,
                });
                this.form = initUserExchangeBulk(bulk);

                let message = "";

                let items_success = this.form.exchanges.filter((item) => item.done && !item.fail);
                let successAmount = items_success.reduce((sum, item) => sum + item.amount, 0);

                let items_failure = this.form.exchanges.filter((item) => !item.done || item.fail);
                if (0 < items_failure.length) {
                    let totalCount = this.form.exchanges.length;
                    let successCount = items_success.length;

                    message = `${totalCount.format()}건 중 ${successCount.format()}건 선물하기에 성공했습니다.`;
                } else {
                    message = `입력하신 연락처로 자동충전URL을 보냈습니다.`;
                }

                message += `\n\n받는 사람: ${phone.phoneNumberFormat()}\n보낸 금액: ${successAmount.format()}원\n\n자세한 내용은 ‘마이페이지 > 상품권 교환소 > 교환 내역’에서 확인하실 수 있습니다.`;

                alert(message);

                this.$refs["exchange-gifts"].exit();
            } finally {
                this.loading = false;
            }
            this.emit();
        },

        async redo() {
            let go = await this.$confirm("해당 선물을 재발송하시겠습니까?");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { bulk } = await api.v1.me.exchanges.bulks.gift.postRedo({
                    _id: this.form._id,
                });
                this.form = initUserExchangeBulk(bulk);

                alert("해당 선물을 재발송하였습니다.");
            } finally {
                this.loading = false;
            }
            this.emit();
            this.$refs["gift-info"].exit();
        },
        async undo() {
            let go = await this.$confirm("해당 선물을 취소하시겠습니까?");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { bulk } = await api.v1.me.exchanges.bulks.gift.postUndo({
                    _id: this.form._id,
                });
                this.form = initUserExchangeBulk(bulk);

                alert("해당 선물을 취소하였습니다.");
            } finally {
                this.loading = false;
            }
            this.emit();
            this.$refs["gift-info"].exit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
